import React, { Component } from 'react';
import { coalesce } from '../misc';
import { TX, wedge_calc } from '../SVGUtil';

const ProgressPie = (props) => {
	let value = props.value || 0;

	let size = coalesce(props.size, 24);

	let radius = size/2-1;

	let w = wedge_calc(value, radius, -90);
	let we;
	if (w.circle) {
		we = <circle className="ad_wedge" r={w.circle.r}/>;
	} else if (w.path) {
		we = <path className="ad_wedge" d={w.path.d}/>;
	}

	return (
		<svg viewBox={`0 0 ${size} ${size}`} width={size} height={size}>
			<g transform={TX.translate(size/2,size/2).str}>
				<circle r={radius}/>
				{we}
			</g>
		</svg>
	);
};

class ProgressPieTimeout extends Component {
	constructor(props) {
		super(props);
		this.state = {value: this.calc_value(props)};
		for (const m of ["update"]) this[m] = this[m].bind(this);
	}

	calc_value(props) {
		return Math.max(0, Math.min(1, (Date.now()/1000 - props.begin_ts) / (props.end_ts - props.begin_ts)));
	}

	update() {
		this.setState({value: this.calc_value(this.props)});
	}

	componentDidMount() {
		this.update();
		this.interval = setInterval(this.update, 500);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render() {
		return <ProgressPie {...this.props} value={this.state.value}/>
	}
}

export { ProgressPie, ProgressPieTimeout };



// WEBPACK FOOTER //
// ./src/c/Progress.js